import getBatteryFeatures from "@/db/BatteryFeatures/index";
export default {
  methods: {
    findFeatureSuffix(field) {
      const features = getBatteryFeatures("Evaporator");
      const bodyKeys = field.split(".");
      const feature = features.find(
        (feature) => feature.bodyKey === bodyKeys[0]
      );
      console.log(feature, "feature", bodyKeys);
      if (!feature) return "";
      if (bodyKeys.length === 1) return "";
      const option = feature.options.find(
        (option) => option.bodyKey === bodyKeys[1]
      );
      console.log(option, "option");
      if (!option) return "";
      return option.suffix;
    },
    getExcelFields() {
      return {
        [this.$t("batteries.id")]: {
          field: "id",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("batteries.name")]: {
          field: "name",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("batteries.type")]: {
          field: "type",
          callback: (value) => {
            return value;
          },
        },
        [this.$t("batteries.isLocked")]: {
          field: "isLocked",
          callback: (value) => {
            return value
              ? this.$t("common.lockedText")
              : this.$t("common.unlockedText");
          },
        },
        [this.$t("batteries.createdAt")]: {
          field: "createdAt",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("batteries.updatedAt")]: {
          field: "updatedAt",
          callback: (value) => {
            return this.$date.format(value);
          },
        },
        [this.$t("batteries.userInfo")]: {
          field: "userInfo",
          callback: (value) => {
            return value.fullname;
          },
        },
        [this.$t("batteries.generalFeatures.geometryName")]: {
          field: "generalFeatures.geometryName",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("generalFeatures.geometryName")
            );
          },
        },
        [this.$t("batteries.generalFeatures.finMaterialName")]: {
          field: "generalFeatures.finMaterialName",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("generalFeatures.finMaterialName")
            );
          },
        },
        [this.$t("batteries.generalFeatures.finThicknessValue")]: {
          field: "generalFeatures.finThicknessValue",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("generalFeatures.finThicknessValue")
            );
          },
        },
        [this.$t("batteries.generalFeatures.tubeThicknessValue")]: {
          field: "generalFeatures.tubeThicknessValue",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("generalFeatures.tubeThicknessValue")
            );
          },
        },
        [this.$t("batteries.generalFeatures.finPitchValue")]: {
          field: "generalFeatures.finPitchValue",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("generalFeatures.finPitchValue")
            );
          },
        },
        [this.$t("batteries.dimensions.length")]: {
          field: "dimensions.length",
          callback: (value) => {
            return value + this.findFeatureSuffix("dimensions.length");
          },
        },
        [this.$t("batteries.dimensions.rowCount")]: {
          field: "dimensions.rowCount",
          callback: (value) => {
            return value + this.findFeatureSuffix("dimensions.rowCount");
          },
        },
        [this.$t("batteries.dimensions.tubeCount")]: {
          field: "dimensions.tubeCount",
          callback: (value) => {
            return value + this.findFeatureSuffix("dimensions.tubeCount");
          },
        },
        [this.$t("batteries.dimensions.noOfCircuit")]: {
          field: "dimensions.noOfCircuit",
          callback: (value) => {
            return value + this.findFeatureSuffix("dimensions.noOfCircuit");
          },
        },
        [this.$t("batteries.refrigerantFeatures.refrigerantName")]: {
          field: "refrigerantFeatures.refrigerantName",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("refrigerantFeatures.refrigerantName")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.subcooling")]: {
          field: "refrigerantFeatures.subcooling",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("refrigerantFeatures.subcooling")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.superheat")]: {
          field: "refrigerantFeatures.superheat",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("refrigerantFeatures.superheat")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.atmospherePressure")]: {
          field: "refrigerantFeatures.atmospherePressure",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("refrigerantFeatures.atmospherePressure")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.condenserTemp")]: {
          field: "refrigerantFeatures.condenserTemp",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("refrigerantFeatures.condenserTemp")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.evaporatorTemp")]: {
          field: "refrigerantFeatures.evaporatorTemp",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("refrigerantFeatures.evaporatorTemp")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.fanFlow")]: {
          field: "refrigerantFeatures.fanFlow",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("refrigerantFeatures.fanFlow")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.airInletHumidity")]: {
          field: "refrigerantFeatures.airInletHumidity",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("refrigerantFeatures.airInletHumidity")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.airInletTemp")]: {
          field: "refrigerantFeatures.airInletTemp",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("refrigerantFeatures.airInletTemp")
            );
          },
        },
        [this.$t("batteries.refrigerantFeatures.wetBulbInlet")]: {
          field: "refrigerantFeatures.wetBulbInlet",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("refrigerantFeatures.wetBulbInlet")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.capacity")]: {
          field: "batteryResultInfo.capacity",
          callback: (value) => {
            return value + this.findFeatureSuffix("batteryResultInfo.capacity");
          },
        },
        [this.$t("batteries.batteryResultInfo.airPressureDrop")]: {
          field: "batteryResultInfo.airPressureDrop",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("batteryResultInfo.airPressureDrop")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.airTemperatureWetbulbOutlet")]: {
          field: "batteryResultInfo.airTemperatureWetbulbOutlet",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix(
                "batteryResultInfo.airTemperatureWetbulbOutlet"
              )
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.airTemperatureOutlet")]: {
          field: "batteryResultInfo.airTemperatureOutlet",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("batteryResultInfo.airTemperatureOutlet")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.airVelocityOutlet")]: {
          field: "batteryResultInfo.airVelocityOutlet",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("batteryResultInfo.airVelocityOutlet")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.airHumidityOutlet")]: {
          field: "batteryResultInfo.airHumidityOutlet",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("batteryResultInfo.airHumidityOutlet")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.passCount")]: {
          field: "batteryResultInfo.passCount",
          callback: (value) => {
            return (
              value + this.findFeatureSuffix("batteryResultInfo.passCount")
            );
          },
        },
        [this.$t("batteries.batteryResultInfo.capacitySensible")]: {
          field: "batteryResultInfo.capacitySensible",
          callback: (value) => {
            return (
              value +
              this.findFeatureSuffix("batteryResultInfo.capacitySensible")
            );
          },
        },
      };
    },
  },
};
